var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.542,
    height: 14.609,
    viewBox: "0 0 18.542 14.609",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Change_photo",
    "data-name": "Change photo",
    transform: "translate(-753.776 -1557.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "camera-outline",
    transform: "translate(706.526 1462.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M60.394,98.158,59.3,96.435a1.181,1.181,0,0,0-.9-.435H54.637a1.181,1.181,0,0,0-.9.435l-1.091,1.723a1.172,1.172,0,0,1-.879.464H49.311A1.311,1.311,0,0,0,48,99.933V107.8a1.311,1.311,0,0,0,1.311,1.311h14.42a1.311,1.311,0,0,0,1.311-1.311V99.933a1.311,1.311,0,0,0-1.311-1.311H61.314A1.252,1.252,0,0,1,60.394,98.158Z",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M100.983,136.9V136H100v.9",
    transform: "translate(-49.87 -38.361)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4450",
    "data-name": "Group 4450",
    transform: "translate(-244.487 -99.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M157.887,154.038l-.351-.408a3.19,3.19,0,1,0,.7,3.266",
    transform: "translate(852.277 1508.695)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M301.347,161.98a.26.26,0,0,0-.185.078l-1.837,1.837a.266.266,0,0,0,.188.454h1.837a.266.266,0,0,0,.266-.266v-1.838a.266.266,0,0,0-.268-.266Z",
    transform: "translate(709.612 1499.646)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeProfileIcon);
export default __webpack_public_path__ + "static/media/change-profile-icon.e7a61d3830a5e9f00d74b21d9ae8947a.svg";
export { ForwardRef as ReactComponent };